import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { popupAndUpsaleTypes } from "../../constants/types";
import { getPopupDataFromPageData } from "../selectors";
import { ADD_FTTB_TARIFF_PAGE_ADDITIONAL_SERVICE, ADD_FTTB_TARIFF_PAGE_SELECTED_ANTIVIRUS, REMOVE_FTTB_TARIFF_PAGE_ADDITIONAL_SERVICE, REMOVE_FTTB_TARIFF_PAGE_SELECTED_ANTIVIRUS, SET_FTTB_TARIFF_PAGE_DATA } from "../actions/actionTypes";
var reducers = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, SET_FTTB_TARIFF_PAGE_DATA, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    fttbTariffPage: _objectSpread(_objectSpread({}, state.fttbTariffPage), {}, {
      originData: payload
    })
  });
}), ADD_FTTB_TARIFF_PAGE_ADDITIONAL_SERVICE, function (state, _ref) {
  var alias = _ref.alias;
  var service = state.fttbTariffPage.originData.upsales.find(function (upsale) {
    return upsale.serviceAlias === alias;
  });
  var selectedAdditionalServices = state.fttbTariffPage.selectedAdditionalServices || [];
  if (selectedAdditionalServices.find(function (s) {
    return s.alias === alias;
  })) return state;
  var newselectedAdditionalServices = [].concat(_toConsumableArray(selectedAdditionalServices), [{
    name: service.name,
    fee: service.initialFee.value,
    unit: service.initialFee.unit,
    alias: service.serviceAlias
  }]);
  return _objectSpread(_objectSpread({}, state), {}, {
    fttbTariffPage: _objectSpread(_objectSpread({}, state.fttbTariffPage), {}, {
      selectedAdditionalServices: newselectedAdditionalServices
    })
  });
}), REMOVE_FTTB_TARIFF_PAGE_ADDITIONAL_SERVICE, function (state, _ref2) {
  var alias = _ref2.alias;
  var filtredAdditionalServices = (state.fttbTariffPage.selectedAdditionalServices || []).filter(function (service) {
    return service.alias !== alias;
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    fttbTariffPage: _objectSpread(_objectSpread({}, state.fttbTariffPage), {}, {
      selectedAdditionalServices: filtredAdditionalServices
    })
  });
}), ADD_FTTB_TARIFF_PAGE_SELECTED_ANTIVIRUS, function (state, _ref3) {
  var alias = _ref3.alias,
    groupAlias = _ref3.groupAlias;
  var selectedAntiviruses = state.fttbTariffPage.selectedAntiviruses || [];
  if (selectedAntiviruses.find(function (antivirus) {
    return antivirus.alias === alias;
  })) return state;
  var antivirusGroup = getPopupDataFromPageData(state.fttbTariffPage.originData, popupAndUpsaleTypes.Antivirus).groups.find(function (group) {
    return group.alias === groupAlias;
  });
  var currentAntivirus = antivirusGroup.antiviruses.find(function (antivirus) {
    return antivirus.alias === alias;
  });
  var filtredSelectedAntivivruses = selectedAntiviruses.filter(function (antivirus) {
    return antivirus.groupAlias !== groupAlias;
  });
  var newselectedAntiviruses = [].concat(_toConsumableArray(filtredSelectedAntivivruses), [{
    alias: alias,
    groupAlias: groupAlias,
    name: currentAntivirus.name,
    fee: currentAntivirus.fee.value,
    unit: currentAntivirus.fee.unit
  }]);
  return _objectSpread(_objectSpread({}, state), {}, {
    fttbTariffPage: _objectSpread(_objectSpread({}, state.fttbTariffPage), {}, {
      selectedAntiviruses: newselectedAntiviruses
    })
  });
}), REMOVE_FTTB_TARIFF_PAGE_SELECTED_ANTIVIRUS, function (state, _ref4) {
  var alias = _ref4.alias;
  var selectedAntiviruses = state.fttbTariffPage.selectedAntiviruses || [];
  var filtredSelectedAntivivruses = selectedAntiviruses.filter(function (antivirus) {
    return antivirus.alias !== alias;
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    fttbTariffPage: _objectSpread(_objectSpread({}, state.fttbTariffPage), {}, {
      selectedAntiviruses: filtredSelectedAntivivruses
    })
  });
});
export var fttbTariffPage = function fttbTariffPage(state, action) {
  var reducer = reducers[action.type];
  return typeof reducer === 'function' ? reducer(state, action.payload) : state;
};